module.exports = "/images/sophia-av.png?a198d380be3815eb04a73dce919ac620";